import React, { useEffect, useRef } from "react";
import { Design, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Com3 = () => {
  const ref = useRef();
  useScrollFadeIn(ref);

  const { t } = useTranslation("landing");
  const language = useSelector(selectLanguage);
  return (
    <Wrapper>
      <img loading="lazy" src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/877cbb59Landing_3.png" alt="" />
      <Design />
      <TextBox ref={ref} className="fade-in" language={language}>
        <span>{t("3-1")}</span>
        <span>{t("3-2")}</span>
        <br />
        <div>
          <p>{t("3-3")}</p>
          <span>{t("3-4")}</span>
        </div>

        <br />
        <div>
          <p>{t("3-5")}</p>
          <span>{t("3-6")}</span>
        </div>
      </TextBox>
    </Wrapper>
  );
};

export default Com3;
